import { createReducer } from 'deox';
import { getAuthUser } from '@/utils';
import { AuthUser } from '@/types';
import { signInActions, logoutUserActions } from '@/redux/actions/auth';

export interface AuthUserState {
  data?: AuthUser;
}

const initialState: AuthUserState = {
  data: getAuthUser(),
};

const apiDocsReducer = createReducer(initialState, (handleAction) => [
  handleAction(signInActions.success, (state) => ({
    ...state,
    data: getAuthUser(),
  })),
  handleAction(logoutUserActions.success, () => ({
    data: undefined,
  })),
]);

export default apiDocsReducer;
